import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const NewsfeedView: React.FC = () => {
  const location = useLocation();
  // Digest emails link to /newsfeed?newsfeed=settings. The widget reads that
  // query on its own document, which is the iframe.
  const src = `/newsfeed/embed${location.search || ''}`;

  return (
    <div className="flex flex-col bg-[#e9eaee]" style={{ height: '100vh' }}>
      <Header />
      <iframe
        title="Newsfeed"
        src={src}
        className="w-full flex-1 border-0"
      />
    </div>
  );
};

export default NewsfeedView;
